import Header from "./Header";
import Table from "./Table";
import { useBrand } from "../hooks/useBrand";
import { Package, Edit, Trash2 } from "lucide-react";

const Brand = () => {
  const { items, loading, error, searchTerm, setSearchTerm, page, setPage } = useBrand();
  return (
    <div>
      <Header title="Brands" />
      <div className="container-fluid py-4">
        <div className="row mb-3 mx-3 align-items-center">
          <div className="col-md-6 mb-2 mb-md-0">
            <input
              type="text"
              className="form-control"
              placeholder="Search brand name..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(1);
              }}
            />
          </div>
        </div>
        {loading && <div className="text-center py-4">Loading...</div>}
        {error && <div className="text-center py-4 text-danger">{error}</div>}
        <Table
          columns={{
            title: "BRANDS",
            headers: [
              { label: "Brand Name", key: "name", className: "border-0 ps-4 fw-bold", cellClassName: "ps-4 fw-bold" },
              {
                label: "Actions",
                key: "actions",
                className: "border-0 pe-4",
                cellClassName: "pe-4",
                cellStyle: { minWidth: 140 },
              },
            ],
          }}
          data={items.map((item) => ({
            ...item,
            actions: (
              <div className="d-flex gap-2">
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => alert(`Edit ${item.name}`)}
                  style={{ minWidth: "40px" }}
                  title="Edit"
                >
                  <Edit size={16} />
                </button>
                <button
                  className="btn btn-outline-danger btn-sm"
                  onClick={() => alert(`Delete ${item.name}`)}
                  style={{ minWidth: "40px" }}
                  title="Delete"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ),
          }))}
          emptyIcon={<Package size={64} className="text-muted mb-3" />}
          emptyTitle="No brands found"
          emptyMessage="Try adjusting your search or add a new brand"
        />
        {/* Pagination */}
        {!loading && !error && items.length > 0 && (
          <div className="d-flex justify-content-center align-items-center gap-2 py-3">
            <button
              className="btn btn-outline-secondary btn-sm"
              disabled={page <= 1}
              onClick={() => setPage((p) => Math.max(1, p - 1))}
            >
              Prev
            </button>
            <span className="small">Page {page}</span>
            <button
              className="btn btn-outline-secondary btn-sm"
              disabled={items.length < 15}
              onClick={() => setPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Brand;
